import { render } from "./navigation.vue?vue&type=template&id=049d1eb4&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"

import "./navigation.vue?vue&type=style&index=0&id=049d1eb4&lang=css"
import "./navigation.vue?vue&type=style&index=1&id=049d1eb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049d1eb4"]])

export default __exports__